// Siglas de la clínica para el título de la pestaña del navegador.
//
// POR QUÉ. El título era "Clínica Dental Esteve · Agenda". Con cuatro o cinco pestañas abiertas
// —agenda, ficha de un paciente, recepción…— el navegador las estrecha y solo se lee "Clínica
// Dent...", que es exactamente la parte que se repite en todas: no sirve para distinguirlas.
// Con las siglas delante ("CDE · Agenda", "CDE · Recepción") lo primero que se ve es DÓNDE estás,
// que es para lo que se mira el título de una pestaña.
export function siglasClinica(nombre) {
  const palabras = String(nombre || '').split(/\s+/).filter(Boolean);
  if (!palabras.length) return 'C';
  // Las preposiciones y artículos no cuentan: "Clínica Dental de Alicante" -> CDA, no CDDA.
  const utiles = palabras.filter(p => !/^(de|del|la|el|los|las|y|e|i)$/i.test(p));
  return (utiles.length ? utiles : palabras).map(p => p[0]).join('').toUpperCase().slice(0, 4);
}

// UN NOMBRE CORTO NO NECESITA SIGLAS, y esto no es un detalle: al poner arriba la marca del
// producto se empezo a llamar a esta funcion con "Biango", que siglasClinica reduce a la letra "B".
// La pestaña ponia literalmente "B · Agenda" — o sea que la marca que se acababa de estrenar se leia
// como una inicial suelta.
//
// Las siglas existen para "Clínica Dental Esteve", que repetido en cinco pestañas no distingue nada.
// Con seis letras no hay nada que comprimir: se pone entero. El limite es generoso a proposito —
// mejor un titulo un poco largo que una inicial que no dice nada.
const LARGO_MAXIMO_ENTERO = 12;

// El título completo: "Biango · Agenda", o "CDE · Agenda" si el nombre es largo.
export function tituloPestana(nombre, seccion) {
  const n = String(nombre || '').trim();
  const cabecera = (n && n.length <= LARGO_MAXIMO_ENTERO) ? n : siglasClinica(n);
  return seccion ? `${cabecera} · ${seccion}` : cabecera;
}
